import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

import { FaIconComponent } from '@akostm/orbit-ui';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'shared-message-text',
  standalone: true,
  imports: [FaIconComponent],
  templateUrl: './message-text.component.html',
  styleUrl: './message-text.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageTextComponent {
  messageText = input.required<string>();
  link = input<boolean>(false);
  readonly openLinkIcon = faArrowUpRightFromSquare;
}
